(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('MusicalArrangementTypeSearch', MusicalArrangementTypeSearch);

    MusicalArrangementTypeSearch.$inject = ['$resource'];

    function MusicalArrangementTypeSearch($resource) {
        var resourceUrl =  'api/_search/musical-arrangement-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
